<article class="gauge-card">
  <header class="gauge-card__title">{{ title }}</header>

  <div class="gauge-card__chart">
    <ngx-charts-gauge
      [animations]="false"
      [results]="results"
      [min]="0"
      [max]="100"
      [angleSpan]="180"
      [startAngle]="-90"
      [legend]="false"
      [customColors]="customColors"
      [units]="''"
      [bigSegments]="0"
      [smallSegments]="0"
      [showAxis]="false"
      [valueFormatting]="valueFormat"
      [tooltipDisabled]="true">
    </ngx-charts-gauge>
  </div>

  <footer class="gauge-card__footer">{{ footerText }}</footer>
</article>
